import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import BotService from "../../../../../services/BotService/BotService";
import RichTextEditor from "react-rte";
import {queryParamGenerator} from "../../../../../helpers/helper";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#FCFCFC",
    },
}));

const StepThree = (props) => {
    const classes = useStyles();
    const [editorState, setEditorState] = useState(props.publishDetail.publish_detail["benefit"] ?
        RichTextEditor.createValueFromString(props.publishDetail.publish_detail["benefit"].toString("html"), "html") :
        RichTextEditor.createEmptyValue());
    const {t} = useTranslation();
    const [data, setData] = useState([]);
    const [securityId, setSecurityId] = useState(
        props.publishDetail.publish_detail["security_stage_id"]
    );
    const [automationTypesId, setAutomationTypesId] = useState(
        props.publishDetail.publish_detail["automation_types_id"]
    );
    const [automType, setAutomType] = useState([]);
    const [categoryVal, setCategoryVal] = useState(props.publishDetail.publish_detail["categories"]);
    const [category, setCategory] = useState([]);
    //const [appVal, setAppVal] = useState([]);
    //const [application, setApplication] = useState([]);
    const [automTypeName, setAutomTypeName] = useState("");

    useEffect(() => {
        if (props.publishDetail.publish_detail.type !== "library") {
            BotService.getBotSecurityFilter().then((response) => {
                if (response) {
                    if (response.data) {
                        response.data.length > 0
                            ? setData(response.data)
                            : setData([response.data]);
                    }
                }
            });
            // Filter Automation Type by name field
            let filter = queryParamGenerator({n: ['Integration', 'Bot']});
            BotService.getAutomationTypesFilter(filter).then((response) => {
                if (response) {
                    if (response.data) {
                        if (response.data?.length) {
                            localStorage.setItem("automType", JSON.stringify(response.data))
                            setAutomType(response.data)
                        } else {
                            setAutomType([response.data]);
                            localStorage.setItem("automType", JSON.stringify([response.data]))
                        }
                    }
                }
            });
        } else {
            let typeName = "";
            let ls = localStorage.getItem("automType");
            if (ls) {
                const filter = JSON.parse(ls).filter(
                    (i) =>
                        i?.id === props?.publishDetail?.publish_detail?.automation_types_id
                );
                if (filter?.length > 0) {
                    setAutomTypeName(filter[0]?.name);
                    typeName = filter[0]?.name;
                }
            }

            // BotService.getApplicationFilter().then((response) => {
            //     if (response) {
            //         if (response.data) {
            //             if (response.data?.length > 0) {
            //                 setApplication(response.data);
            //             } else {
            //                 setApplication([response.data]);
            //             }

            //             let filteredData = props.publishDetail.publish_detail[
            //                 "applications"
            //             ].map((item) => response.data.filter((itx) => itx.id === item.id));
            //             let filter = filteredData.map((item) => item[0]);

            //             setAppVal(filter);
            //         }
            //     }
            // });

            BotService.getCategoryFilter().then((response) => {
                if (response) {
                    if (response.data) {
                        response.data.length > 0
                            ? setCategory(response.data)
                            : setCategory([response.data]);
                        if (props.publishDetail.publish_detail["categories"].length > 0) {
                            let filteredData = props.publishDetail.publish_detail[
                                "categories"
                                ].map((item) => response.data.filter((itx) => itx.id === item));
                            let filter = filteredData.map((item) => item[0]);
                            setCategoryVal(filter);
                        }
                    }
                }
            });
        }
    }, []);

    useEffect(() => {
        let newCategoryVal = categoryVal.map((item) => item.id);

        // let newAppVal = appVal.map((item) => ({
        //     id: item.id,
        //     type: "APPLICATION",
        // }));

        if (props.publishDetail.publish_detail.type === "library") {
            props.setPublishDetail((oldState) => ({
                publish_detail: {
                    ...oldState.publish_detail,
                    //applications: newAppVal,
                    categories: newCategoryVal,
                },
            }));
            if (
                newCategoryVal.length > 0
                //newAppVal.length > 0
            ) {
                props.setIsRequired(false);
            } else {
                props.setIsRequired(true);
            }
        } else {
            if (automationTypesId.length > 0) {
                props.setIsRequired(false);
            } else {
                props.setIsRequired(true);
            }

            props.setPublishDetail((oldState) => ({

                publish_detail: {
                    ...oldState.publish_detail,
                    automation_types_id: props.publishDetail.publish_detail.type !== "library" ? automationTypesId : "6a9cdfd5-52c0-4ff9-b50f-ef1206064219"
                },
            }));
        }
    }, [categoryVal, automationTypesId]);

    const handleEdit = (value) => {
        setEditorState(value);
        props.setPublishDetail((oldState) => ({
            publish_detail: {
                ...oldState.publish_detail,
                benefit: editorState,
            },
        }));
    };

    const handleChange = e => {
        props.setPublishDetail((oldState) => ({
            publish_detail: {
                ...oldState.publish_detail,
                applications: [],
            },
        }))
        setAutomationTypesId(e.target.value)
    }
    return (
        <DialogContent style={{padding: "20px 0 0 0"}}>
            <div style={{textAlign: "left"}}>

                {props.publishDetail.publish_detail.type === "library" ? (
                    <Grid container>
                        <Grid item xs={12}>
                            <span className="dialog-text">{t("CONTENT.PUBLISH.CATEGORY")}</span>
                            <div className={classes.root}>
                                <Autocomplete
                                    multiple
                                    id="tags-outlined1"
                                    value={categoryVal}
                                    options={category}
                                    getOptionLabel={(option) => {
                                        //filter value
                                        return `${option.name}`;
                                    }}
                                    size="small"
                                    onChange={(event, value) => setCategoryVal(value)}
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined"/>
                                    )}
                                />
                            </div>
                        </Grid>
                        {/* <Grid item xs={12} style={{ marginTop: "1rem" }}>
                            <span className="dialog-text">
                                {t("CONTENT.PUBLISH.APPLICATION")}
                            </span>
                            <div className={classes.root}>
                                <Autocomplete
                                    multiple
                                    id="tags-outlined3"
                                    options={application}
                                    value={appVal}
                                    getOptionLabel={(option) => {
                                        //filter value
                                        return `${option.name}`;
                                    }}
                                    size="small"
                                    onChange={(event, value) => setAppVal(value)}
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" />
                                    )}
                                />
                            </div>
                        </Grid> */}
                        <Grid item xs={3} style={{marginTop: "1rem"}}>
                            <span className="dialog-text">{t("CONTENT.PUBLISH.UTILITY")}</span>
                        </Grid>
                        <Grid item xs={12}>
                            <RichTextEditor
                                editorClassName="publish-editor"
                                value={editorState}
                                onChange={(value) => handleEdit(value)}
                            />
                        </Grid>
                    </Grid>

                ) : (
                    <Grid container>
                        <Grid item xs={12}>
                            <span className="dialog-text">
                                {t("CONTENT.PUBLISH.AUTOM-TYPE")}
                            </span>
                            <FormControl style={{width: '100%'}}>
                                <Select
                                    variant="outlined"
                                    style={{
                                        height: "40px",
                                        // width: "15rem",
                                        backgroundColor: "#FCFCFC",
                                        fontSize: "12px",
                                    }}
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    value={automationTypesId}
                                    onChange={(e) => handleChange(e)}
                                >
                                    {automType.length > 0 ? (
                                        automType.map(
                                            (item, index) =>
                                                item !== undefined && item.name !== "Library" && (
                                                    <MenuItem
                                                        style={{fontSize: "12px"}}
                                                        key={item.id}
                                                        value={item.id}
                                                    >
                                                        {item.name}
                                                    </MenuItem>
                                                )
                                        )
                                    ) : (
                                        <MenuItem style={{fontSize: "12px"}}/>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                        {/* <Grid item xs={props.publishDetail.publish_detail.type !== "library" ? 6 : 12}>
                            <div>
                            <span className="dialog-text">
                            {props.publishDetail.publish_detail.type === "library" ? "Library " : "Bot "}
                                {t("CONTENT.PUBLISH.AUTOM-SECURITY-STAGE")}
                            </span>
                            </div>
                            <FormControl>
                                <Select
                                    variant="outlined"
                                    style={{
                                        height: "40px",
                                        width: "15rem",
                                        backgroundColor: "#FCFCFC",
                                        fontSize: "12px",
                                    }}
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    value={securityId}
                                    onChange={(e) => setSecurityId(e.target.value)}
                                >
                                    {data.length > 0 ? (
                                        data.map(
                                            (item, index) =>
                                                item !== undefined && (
                                                    <MenuItem
                                                        style={{fontSize: "12px"}}
                                                        key={item.id}
                                                        value={item.id}
                                                    >
                                                        {item.name}
                                                    </MenuItem>
                                                )
                                        )
                                    ) : (
                                        <MenuItem style={{fontSize: "12px"}}/>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid> */}
                        <Grid item xs={3} style={{marginTop: "1rem"}}>
                            <span className="dialog-text">{t("CONTENT.PUBLISH.UTILITY")}</span>
                        </Grid>
                        <Grid item xs={12}>
                            <RichTextEditor
                                editorClassName="publish-editor"
                                value={editorState}
                                onChange={(value) => handleEdit(value)}
                            />
                        </Grid>
                    </Grid>
                )}
            </div>
        </DialogContent>
    );
};

export default StepThree;
